import { createSelector } from 'reselect';

const messageSelector = state => state.messages;

export const getMessageSelector = createSelector(
  messageSelector,
  messages => (messages || [])[0]
);
